module.exports = __webpack_public_path__ + "static/edinme-seo-16697028e6bee45faeb39720c2de56ae.png";